module.exports = __webpack_public_path__ + "img/1.5fbe15a1.png";